module.exports = __webpack_public_path__ + "img/center11.e4522562.png";